import Link from 'next/link'
import BidCountdown from '@components/BidCountdown/BidCountdown'
import { C } from '@components/MainLayout/reusable/helpers'
import BidButton from '../../elements/BidButton/BidButton'
import BackToItemList from '@components/Details/BackToItemList'
import {
  formatEndDate,
  formatPickupDate,
} from '@components/Details/AuctionDetailInfo'
import getEasternTimezone from '@utilities/functions/getEasternTimezone'

const Sidebar = ({
  title,
  auctionNumber,
  auction,
  showBackButton,
  address,
  city,
  state,
  isFranchise,
  zip,
  pageNumber,
  utcEndDateTime,
  itemClosed,
  auctionPickupDates,
  setInfoSlideOutOpen,
  itemId,
  endTimeText,
}: any) => {
  const endDateEasternTime = getEasternTimezone(new Date(utcEndDateTime))
  return (
    <div className="flex-col justify-between w-full h-full text-xs border-r border-bidfta-gray-border overflow-y-auto bg-white">
      <div>
        <div className="py-3 px-7 border-b border-bidfta-gray-border">
          <h3 className="font-bold text-20 leading-tight">{title}</h3>
          <div className="my-3">
            <BidButton
              label="View Auction Info"
              theme="blue-light"
              callBack={() =>
                setInfoSlideOutOpen((prevState: any) => !prevState)
              }
              width="full"
              buttonStyle="hollow"
            />
          </div>
        </div>
        <div className="py-3 px-7 border-b border-bidfta-gray-border text-bidfta-blue-light font-bold ">
          <Link
            href={`/auction-detail/${auction.id}/1`}
            className="hover:underline"
          >
            {auctionNumber}
          </Link>
        </div>
        {showBackButton && (
          <div className="py-3 px-7 border-b border-bidfta-gray-border">
            <BackToItemList
              auctionId={auction.id}
              pageNumber={pageNumber}
              itemId={itemId}
            />
          </div>
        )}
        <div className="py-3 px-7 border-b border-bidfta-gray-border">
          <h4 className="font-bold text-sm leading-tight uppercase mb-1">
            Location:
          </h4>
          <p>{address}</p>
          <p>
            {city}, {state} {zip}
          </p>
          {isFranchise ? (
            <div className="mb-4 mt-2">
              <h2 className="text-md font-bold mb-1">Affiliate</h2>
              <p className="text-gray-700">Independently owned and operated</p>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="py-3 px-7 border-b border-bidfta-gray-border">
          <h4 className="font-bold text-sm leading-tight uppercase mb-1">
            Auction End Date:
          </h4>
          <div className="mb-1">
            <p>{formatEndDate(endDateEasternTime)}</p>
            <span>{endTimeText} EST</span>
          </div>
          <BidCountdown
            date={utcEndDateTime}
            hideClock
            itemClosed={itemClosed}
          />
        </div>
        <div className="py-3 px-7 border-b border-bidfta-gray-border">
          <h4 className="font-bold text-sm leading-tight uppercase">
            Pick Up Dates: (Local Times)
          </h4>
          {auctionPickupDates.map((pickupDate: any, i: any) => {
            return (
              <div
                className={`py-1 border-bidfta-gray-border ${
                  auctionPickupDates.length !== i + 1 ? 'xl:border-b' : ''
                }`}
                key={pickupDate.id}
              >
                <p className="font-normal pb-1">
                  {formatPickupDate(pickupDate.pickupStartTime)}
                </p>
                <span className="text-10">
                  {pickupDate.pickupStartTimeText} -{' '}
                  {pickupDate.pickupEndTimeText}
                </span>
              </div>
            )
          })}
        </div>
        <div className="pt-6 px-7 mb-5">
          <div>
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              Questions?
            </h4>
            <a
              href={C.AUCTION_CONTACT}
              className="text-bidfta-blue-light underline"
            >
              Contact Us Here
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
